module.exports = __webpack_public_path__ + "img/torres-bulevares.542966d6.png";